export const DEFAULT_DATA_SOURCE_ID = 101;